import React, { Component } from 'react';
import { Icon } from '@material-ui/core';
import { isEqualDay, isPastDay, stringDateToFormat } from '../../../Common';
import { DATETIME_FORMAT_ISO, getIsoDatetimeFromJobDatetime } from '../../../utils/StringDateUtil';

export interface ActionTagHandler {
  actionType: string;
  actionTypeName: string;
  actionDate: string;
  actionTimeFrom?: string;
  tagName?: string;
  today: string;
}

const isPastAction = (actionDateString: string, todayString: string): boolean => {
  const todayDateFormatted = stringDateToFormat(getIsoDatetimeFromJobDatetime(todayString), DATETIME_FORMAT_ISO);
  const actionDateFormatted = stringDateToFormat(actionDateString, 'yyyy/MM/dd');

  if (!todayDateFormatted || !actionDateFormatted) {
    return false;
  }
  return isPastDay(actionDateFormatted, todayDateFormatted) || isEqualDay(actionDateFormatted, todayDateFormatted);
};

export default class ActionTag extends Component<ActionTagHandler, any> {
  render() {
    const { actionType, actionTypeName, actionDate, actionTimeFrom, tagName, today } = this.props;

    const pastActionClass = isPastAction(actionDate, today) ? 'action-warning-tag' : '';

    return (
      <span className={`uc-tag uc-tag--large u-mr8 u-mv4 ${pastActionClass}`} data-testid-e2e='actionTag'>
        <Icon className='u-text-l u-text-middle u-mr4'>{actionType}</Icon>
        <span className='u-text-middle' data-testid='utActionItemInfo' data-testid-e2e='actionItemInfo'>
          {`${actionTypeName}${'　'}${actionDate}`}
          {actionTimeFrom && ` ${actionTimeFrom}`}
          {tagName && `（${tagName}）`}
        </span>
      </span>
    );
  }
}
